import { api } from "../../../api/apiSlice";

// Branch-wise master for the Technical Service Report checklist (battery
// volt, PIR tested, etc.) - lets the business define its own item list
// instead of a hardcoded one. No delete endpoint - once an item has been
// used on a real Service Report, removing it would orphan that historical
// value, so retiring an item is IsActive=false only (see Update).
export const checklistItemsApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getChecklistItems: builder.query({
      query: (params) => ({ url: "/technical/checklist-items", params }),
      providesTags: (result) =>
        result
          ? [
              ...result.map((c) => ({ type: "MasterTechnicalChecklistItems", id: c.checklistItemId })),
              { type: "MasterTechnicalChecklistItems", id: "LIST" },
            ]
          : [{ type: "MasterTechnicalChecklistItems", id: "LIST" }],
    }),
    createChecklistItem: builder.mutation({
      query: (body) => ({ url: "/technical/checklist-items", method: "POST", data: body }),
      invalidatesTags: [{ type: "MasterTechnicalChecklistItems", id: "LIST" }],
    }),
    updateChecklistItem: builder.mutation({
      query: ({ checklistItemId, ...body }) => ({
        url: `/technical/checklist-items/${checklistItemId}`,
        method: "PUT",
        data: body,
      }),
      invalidatesTags: [{ type: "MasterTechnicalChecklistItems", id: "LIST" }],
    }),
  }),
  overrideExisting: false,
});

export const {
  useGetChecklistItemsQuery,
  useCreateChecklistItemMutation,
  useUpdateChecklistItemMutation,
} = checklistItemsApi;
